// import { Validator, Schema } from "jsonschema";
import { Logger, Step, StepEvent, StepPackage, WorkflowContext } from '@samelogic/steps';
import { StepConfig } from '../../../models';
import { buildInputPropsFromContext } from './utils/buildInputPropsFromContext';
import { v4 } from 'uuid';

/**
 * StepContainers are used to isolate the step package from the rest of the application.
 * A Step has a few events:
 * - initialize (constructor) - this will setup the infrastructure (logger, broker, config, package)
 * - run - can be called multiple times with new properties
 * - dispose - used to dispose/stop the step.
 */
export class StepContainer {
  // private readonly validator = new Validator();

  private readonly packageInstance: Step<unknown>;

  /**
   * This handler is triggered
   */
  public onEventTriggered?: (event: StepEvent) => Promise<void>;

  /**
   * This is the props created from the interpolation of the config and the context
   */
  private readonly inputProps: unknown;

  public readonly instanceId: string;

  constructor(
    private readonly context: WorkflowContext,
    stepPackage: StepPackage,
    config: StepConfig,
    logger: Logger
  ) {
    const schema = stepPackage.schema;

    this.inputProps = buildInputPropsFromContext(context, config, schema.props);

    const StepModule = stepPackage.module;
    this.packageInstance = new StepModule(logger);
    this.packageInstance.onEventTriggered = this.handlePackageEventTriggered;

    // eslint-disable-next-line
    this.instanceId = v4();
  }

  public async run(): Promise<void> {
    return this.packageInstance.run(this.context, this.inputProps);
  }

  private handlePackageEventTriggered = async (event: StepEvent) => {
    // TODO: Validate event against schema
    await this.onEventTriggered?.(event);
  };

  public async dispose(): Promise<void> {
    return this.packageInstance.dispose();
  }
}
